export var hasDeposit = function (_a) {
    var invoiceDepositUoUEnabled = _a.invoiceDepositUoUEnabled, depositAmount = _a.depositAmount, paidAmount = _a.paidAmount;
    return (invoiceDepositUoUEnabled &&
        !!depositAmount &&
        depositAmount - paidAmount > 0);
};
//# sourceMappingURL=hasDeposit.js.map